import { Button, TextField } from "@mui/material";
import styles from "./list.module.css";
import axios from "axios";
import { forwardRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { authData } from "../../components/GetAuth";

const CustomInput = forwardRef((props, ref) => (<TextField {...props} inputRef={ref} id="outlined-basic" label="Monthly Amount(&pound;)*" variant="outlined" />));

const AddSubscriptionForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      monthly_amount: "",
    },
  });


  useEffect(() => {
    if (editData) {
      setValue("name", editData?.name);
      setValue("description", editData?.description);
      setValue("monthly_amount", editData?.monthly_amount);
      setValue("no_of_booking", editData?.no_of_booking);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    data.yearly_amount = 0;
    setLoading(true);
    setFormOpen(false);
    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/subscriptions/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/subscriptions", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return [response.data.data].concat(prev);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("name", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
        />
        {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("description", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Description*" variant="outlined" />)}
        />
        {errors.description && (<span className={`ErrorM`}>{errors?.description?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("monthly_amount", { required: "This field is Required" })}
          render={({ field }) => (<NumericFormat {...field} customInput={CustomInput} decimalScale={2} />)}
        />

        {errors.monthly_amount && (<span className={`ErrorM`}>{errors?.monthly_amount?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("no_of_booking", { required: "This field is Required" })}
          render={({ field }) => (<NumericFormat {...field} customInput={CustomInput} decimalScale={0} />)}
        />

        {errors.no_of_booking && (<span className={`ErrorM`}>{errors?.no_of_booking?.message}</span>)}
      </div>

    </div>
    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
    </div>
  </form>);
};

export default AddSubscriptionForm;